export class StatusCodeError extends Error {
	constructor(
		public statusCode: number,
		message?: string,
	) {
		super(message || statusCode.toString());
	}
}
